import React from "react";
import { Container } from "react-bootstrap";
import ProductAssistantWidget from "features/productAssistant/ProductAssistantWidget";

const LoganAI: React.FC = () => {
  document.title = "Logan AI";

  return (
    <div className="page-content logan-ai-page">
      <Container fluid>
        <ProductAssistantWidget variant="page" />
      </Container>
    </div>
  );
};

export default LoganAI;
